import React from 'react'
import { LayoutV2 } from '../../components/common'

const TermsOfServicePage = ({ data = {} }) => {
  return (
    <LayoutV2 query={data} title="PGA.Coach">
      <div class="ot-form-wrapper">
        <iframe
          src="https://privacyportal.onetrust.com/webform/d026f30a-622a-40b3-b261-d78a6b839240/ae8a40ab-c486-4b0f-842f-07d3cdeaaf85"
          title="form"
        ></iframe>
      </div>
    </LayoutV2>
  )
}

export default TermsOfServicePage
